import { useState, useEffect } from 'react'
import { db } from '../modules/firebase'
import snapshotParser from '../helpers/snapshotparser'

const useShippingCost = (deps = []) => {
  const [cost, setCost] = useState(0)

  const handleFetch = async () => {
    const snapshot = await db.doc('config/main').get()
    const data = snapshotParser(snapshot)
    console.log(data)
    setCost(data.shippingCost)
  }

  useEffect(() => {
    handleFetch()
  }, deps)

  return cost
}

export default useShippingCost
